import type { StaticFieldSelectProps } from "./static-field-select.type";

import { Form, Select } from "antd";
import { useTranslation } from "react-i18next";

import { STATIC_FIELD_VALUES } from "@/ui/static-field";

export const StaticFieldSelect = ({
  type,
  name,
  ...selectProps
}: StaticFieldSelectProps) => {
  const { t } = useTranslation();

  const options = STATIC_FIELD_VALUES.map((value) => ({
    value,
    label: t(`form:staticField.${type}.levels.${value}`),
  }));

  return (
    <Form.Item label={t(`form:staticField.${type}.label`)} name={name}>
      <Select
        placeholder={t(`form:staticField.${type}.placeholder`)}
        {...selectProps}
        options={options}
      />
    </Form.Item>
  );
};
